<template>
  <el-input :value="inputValue" @input="onInput" @focus="fHandleFocus" @blur="onBlur" :autocomplete="autocomplete" :readonly="readonly"

    :placeholder="placeholder" :size="size" :disabled="disabled" class="x-number-inp" style="width: 100%;" :type="type"
    :show-password="showPassword" :maxlength="maxlength" ref="numberInput">
    <template v-if="$slots.prepend" slot="prepend">
      <slot name="prepend"></slot>
    </template>
    <template v-if="$slots.append" slot="append">
      <slot name="append"></slot>
    </template>
  </el-input>
  <!-- 使用示例 -->
  <!-- <x-number-inp v-model="now_start_jf" :min="-100" :max="200" :allowNegative="true" placeholder="请输入数字">
        <template #prepend>￥</template>
        <template #append>分</template>
    </x-number-inp> -->
</template>

<script>
export default {
  name: 'XNumberInp',
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 9999999
    },
    placeholder: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number,
      default: 20
    },
    //是否允许负数
    allowNegative: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    },
    // 限制小数点后位数，null表示不限制
    decimalPlaces: {
      type: Number,
      default: null,
      validator: val => val === null || (Number.isInteger(val) && val >= 0)
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    showPassword: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    readonly: {
      type: Boolean,
      default: false
    },
    focus: {
      type: Function,
      default: () => {}
    }

  },
  data() {
    return {
      inputValue: this.valueToString(this.value)
    }
  },
  watch: {
    value(val) {
      // 保证 inputValue 始终为字符串
      this.inputValue = this.valueToString(val);
    }
  },
  computed: {
    displayValue() {
      if (this.value === null || this.value === undefined) return '';
      return String(this.value);
    }
  },
  methods: {
    valueToString(val) {
      if (val === null || val === undefined) return '';
      return String(val);
    },
    onInput(val) {
      let filtered = val;
      if (this.allowNegative) {
        // 只允许数字、-、.
        filtered = filtered.replace(/[^0-9.\-]/g, '');
        // 只保留第一个负号且在开头
        filtered = filtered.replace(/(?!^)-/g, '');
        if (filtered.indexOf('-') > 0) filtered = filtered.replace('-', '');
        // 如果 decimalPlaces 为 0，则移除所有小数点
        if (this.decimalPlaces === 0) {
          filtered = filtered.replace(/\./g, '');
        } else {
          // 只保留第一个小数点
          const firstDot = filtered.indexOf('.');
          if (firstDot !== -1) {
            // 限制小数点后的位数
            if (this.decimalPlaces !== null && this.decimalPlaces >= 0) {
              // 保留指定的小数位数
              filtered = filtered.slice(0, firstDot + 1 + this.decimalPlaces);
            }
            // 移除多余的小数点
            filtered = filtered.slice(0, firstDot + 1) + filtered.slice(firstDot + 1).replace(/\./g, '');
          }
        }
        // 只允许 '-', '.', '-.' 直接 emit
        if (filtered === '-' || filtered === '.' || filtered === '-.') {
          this.inputValue = filtered;
          this.$emit('input', filtered);
          return;
        }
      } else {
        // 只允许数字和小数点
        filtered = filtered.replace(/[^0-9.]/g, '');
        // 如果 decimalPlaces 为 0，则移除所有小数点
        if (this.decimalPlaces === 0) {
          filtered = filtered.replace(/\./g, '');
        } else {
          // 只保留第一个小数点
          const firstDot = filtered.indexOf('.');
          if (firstDot !== -1) {
            // 限制小数点后的位数
            if (this.decimalPlaces !== null && this.decimalPlaces >= 0) {
              // 保留指定的小数位数
              filtered = filtered.slice(0, firstDot + 1 + this.decimalPlaces);
            }
            // 移除多余的小数点
            filtered = filtered.slice(0, firstDot + 1) + filtered.slice(firstDot + 1).replace(/\./g, '');
          }
        }
        if (filtered === '.') {
          this.inputValue = filtered;
          this.$emit('input', filtered);
          return;
        }
      }
      // 验证范围并修正
      filtered = this.fValidateRange(filtered);
      this.inputValue = filtered;
      this.$emit('input', filtered);
    },
    /**
     * 验证值是否在min和max范围内，并返回修正后的值
     * @param {string|number} val - 要验证的值
     * @returns {string} 修正后的值
     */
    fValidateRange(val) {
      

      if (val === '' || val === '-' || val === '.' || val === '-.') return val;


      let num = Number(val);
      if (isNaN(num)) return val;


      // 检查是否小于最小值
      if (num < this.min) {
        return String(this.min);
      }
      // 检查是否大于最大值
      if (num > this.max) {
        return String(this.max);
      }
      // 在范围内则返回原值
      return val;
    },
    
    /**
     * 处理输入框获取焦点事件
     * 当输入框获取焦点时，自动全选内容
     */
    fHandleFocus(event) {
      // 调用用户传入的focus回调函数
      if (typeof this.focus === 'function') {
        this.focus(event);
      }
      
      // 使用setTimeout确保在DOM更新后执行全选操作
      setTimeout(() => {
        const inputElement = this.$refs.numberInput && this.$refs.numberInput.$refs.input;
        if (inputElement && document.activeElement === inputElement) {
          inputElement.select();
        }
      }, 0);
    },


    onBlur(e) {
      let val = e.target.value;
      let filtered = val;
      if (this.allowNegative) {
        filtered = filtered.replace(/[^0-9.\-]/g, '');
        filtered = filtered.replace(/(?!^)-/g, '');
        if (filtered.indexOf('-') > 0) filtered = filtered.replace('-', '');
        // 如果 decimalPlaces 为 0，则移除所有小数点
        if (this.decimalPlaces === 0) {
          filtered = filtered.replace(/\./g, '');
        } else {
          const firstDot = filtered.indexOf('.');
          if (firstDot !== -1) {
            // 限制小数点后的位数
            if (this.decimalPlaces !== null && this.decimalPlaces >= 0) {
              // 保留指定的小数位数
              filtered = filtered.slice(0, firstDot + 1 + this.decimalPlaces);
            }
            // 移除多余的小数点
            filtered = filtered.slice(0, firstDot + 1) + filtered.slice(firstDot + 1).replace(/\./g, '');
          }
        }
      } else {
        filtered = filtered.replace(/[^0-9.]/g, '');
        // 如果 decimalPlaces 为 0，则移除所有小数点
        if (this.decimalPlaces === 0) {
          filtered = filtered.replace(/\./g, '');
        } else {
          const firstDot = filtered.indexOf('.');
          if (firstDot !== -1) {
            // 限制小数点后的位数
            if (this.decimalPlaces !== null && this.decimalPlaces >= 0) {
              // 保留指定的小数位数
              filtered = filtered.slice(0, firstDot + 1 + this.decimalPlaces);
            }
            // 移除多余的小数点
            filtered = filtered.slice(0, firstDot + 1) + filtered.slice(firstDot + 1).replace(/\./g, '');
          }
        }
      }
      this.inputValue = filtered;
      this.$emit('input', filtered);
    }
  }
};
</script>

<style scoped>
/* .x-number-inp {
  display: flex;
  align-items: center;
} */
</style>


// WEBPACK FOOTER //
// src/components/xNumberInp.vue